/* ZAKDOR — Lightweight Async & Network Feedback (Optimized for 2GB RAM Devices)
   Coordinates seamlessly with zk-page-loader
   1. Real async button feedback (clears the exact millisecond server responds)
   2. Real network connection monitor (offline/slow network detection)
   3. Zero duplicate event listeners, zero DOM bloat
*/
(function () {
  'use strict';
  if (window.__axLoad) return;
  window.__axLoad = 1;

  var CSS = ''
    /* Real-time button loading spinner */
    + '.ax-loading{position:relative!important;pointer-events:none!important}'
    + '.ax-loading::after{content:""!important;position:absolute!important;top:50%!important;left:50%!important;'
    +   'width:18px!important;height:18px!important;margin:-9px 0 0 -9px!important;'
    +   'border:2.2px solid rgba(255,255,255,0.3)!important;border-top-color:#FFFFFF!important;border-radius:50%!important;'
    +   'animation:ax-spin 0.6s linear infinite!important;z-index:10!important}'
    + '.ax-loading.light::after{border-color:rgba(10,23,48,0.2)!important;border-top-color:#0A1730!important}'
    + '@keyframes ax-spin{to{transform:rotate(360deg)}}'

    /* Native network connection toast */
    + '.ax-net-toast{position:fixed;top:16px;left:50%;transform:translateX(-50%) translateY(-100px);'
    +   'background:#0A1730;color:#FFFFFF;padding:10px 20px;border-radius:30px;font-family:"Inter",-apple-system,sans-serif;'
    +   'font-size:12.5px;font-weight:700;display:flex;align-items:center;gap:8px;box-shadow:0 12px 30px rgba(0,0,0,0.25);'
    +   'z-index:2147483647;transition:transform 0.3s cubic-bezier(0.16,1,0.3,1),opacity 0.25s;opacity:0;pointer-events:none}'
    + '.ax-net-toast.show{transform:translateX(-50%) translateY(0);opacity:1}'
    + '.ax-net-toast.warn{background:#DC2626;color:#FFFFFF}'
    + '.ax-net-toast.ok{background:#059669;color:#FFFFFF}';

  var st = document.createElement('style');
  st.textContent = CSS;
  document.head.appendChild(st);

  /* Network offline/online alerts */
  var toast = null, toastTimer = null;

  function showToast(msg, type, duration) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ax-net-toast';
      document.body.appendChild(toast);
    }
    toast.className = 'ax-net-toast show ' + (type || '');
    toast.innerHTML = (type === 'warn'
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>')
      + '<span>' + msg + '</span>';

    clearTimeout(toastTimer);
    if (duration) {
      toastTimer = setTimeout(function () {
        toast.classList.remove('show');
      }, duration);
    }
  }

  window.addEventListener('offline', function () {
    showToast('Network connection lost. Please check your internet.', 'warn', 0);
  });

  window.addEventListener('online', function () {
    showToast('Internet connection restored.', 'ok', 3000);
  });

  /* Async Cart Button Loading Feedback */
  var busyButtons = [];

  function setButtonLoading(btn) {
    if (!btn || btn.classList.contains('ax-loading')) return;
    btn.classList.add('ax-loading');
    busyButtons.push(btn);
  }

  function clearButtonLoading() {
    while (busyButtons.length > 0) {
      var b = busyButtons.pop();
      if (b) b.classList.remove('ax-loading');
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest) return;
    var isAjax = f.closest('product-form-component,form[action*="/cart/add"],.cart-discount,cart-drawer');
    if (isAjax) {
      var submitBtn = f.querySelector('button[type="submit"],.button[name="add"]');
      if (submitBtn) setButtonLoading(submitBtn);
    }
  }, true);

  document.addEventListener('shopify:cart:lines-update', clearButtonLoading);
  document.addEventListener('shopify:cart:discount-update', clearButtonLoading);
  document.addEventListener('shopify:section:load', clearButtonLoading);
  document.addEventListener('cartLinesUpdate', clearButtonLoading);
  document.addEventListener('cartError', clearButtonLoading);
})();
